import { render, staticRenderFns } from "./Phone.vue?vue&type=template&id=ad294366&scoped=true&"
import script from "./Phone.vue?vue&type=script&lang=js&"
export * from "./Phone.vue?vue&type=script&lang=js&"
import style0 from "./Phone.vue?vue&type=style&index=0&id=ad294366&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad294366",
  null
  
)

export default component.exports